import {useMutation, useQueryClient} from "@tanstack/react-query";
import {DashboardApi} from "../DashboardApi";
import {Dashboard} from "../model/dashboard/Dashboard";
import {
    defaultMutationOptions,
    defaultResponseHandler,
    IMutationOptions,
    IQueryOptions,
    QueryKey,
    useQueryWrapper
} from "./api-hooks-common";

export const useGetDashboardsInfo = (dashboardsIds: Array<number>, options?: IQueryOptions) => useQueryWrapper([QueryKey.DASHBOARD, ...dashboardsIds.toString()], () => DashboardApi.getDashboardsInfos(dashboardsIds), null, options);

export const useGetDashboard = (dashboardId: number, options?: IQueryOptions<Dashboard>) => useQueryWrapper([QueryKey.DASHBOARD, dashboardId.toString()], () => DashboardApi.getDashboard(dashboardId), null, options);

export const useUpdateDashboard = (specOptions?: IMutationOptions) => {
    const options = {...defaultMutationOptions, ...specOptions};
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dashboard: Dashboard) => {
           return DashboardApi.updateDashboard(dashboard).then(defaultResponseHandler)},
        onSuccess: (data) => {
            queryClient.setQueryData([QueryKey.DASHBOARD, data!!.id.toString()], () => {
                return data;
            });
            options.onSuccess!!();
        },
        onError: error => {
            options.onFailure!!(error);
        },
        onMutate: variables => {
            options.onMutate!!(variables);
        }
    });
};